module.exports = __webpack_public_path__ + "static/media/5.6f6aa813.gif";